import { useEffect, useState } from 'react';

import { personalizedReadingHubSubject } from '@utils/blueconic/constants';
import { BlueconicPersonalizedReadingHubEvent } from '@utils/blueconic/eventsInterfaces';

export interface ReadingStatProps {
  articlesRead: string;
  favoriteAuthors: string[];
  minutesRead: string;
  mostReadNewsletters: string[];
  mostReadTopic: string;
  mostReadTopics: string[];
  recommendedArticles: string[];
  recommendedAuthors: string[];
  recommendedNewsletters: string[];
  trendingTopics: string[];
  userId: string;
}

const useBlueConicPersonalizedReadingHub = (): ReadingStatProps => {
  const [readingStats, setReadingStats] = useState<ReadingStatProps>({
    articlesRead: '',
    favoriteAuthors: [],
    minutesRead: '',
    mostReadNewsletters: [],
    mostReadTopic: '',
    mostReadTopics: [],
    recommendedArticles: [],
    recommendedAuthors: [],
    recommendedNewsletters: [],
    trendingTopics: [],
    userId: '',
  });

  useEffect(() => {
    const handleBlueconicEvent = (data: BlueconicPersonalizedReadingHubEvent) => {
      const {
        data: {
          articlesRead,
          favoriteAuthors,
          minutesRead,
          mostReadNewsletters,
          mostReadTopic,
          mostReadTopics,
          recommendedArticles,
          recommendedAuthors,
          recommendedNewsletters,
          trendingTopics,
          userId,
        },
      } = data;

      setReadingStats({
        articlesRead,
        favoriteAuthors,
        minutesRead,
        mostReadNewsletters,
        mostReadTopic,
        mostReadTopics,
        recommendedArticles,
        recommendedAuthors,
        recommendedNewsletters,
        trendingTopics,
        userId,
      });
    };

    const subscription = personalizedReadingHubSubject.subscribe(handleBlueconicEvent);

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  return readingStats;
};

export default useBlueConicPersonalizedReadingHub;
